<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import FormViewer from '@components/admin/form-viewer'
import { fetchDeposit } from '@apis/admin/deposit'
import fromPairs from 'lodash/fromPairs'

export default {
  components: { FormViewer },
  props: {
    deposit_seq: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      info: {},
      field_values: [],
      forms: [],
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadInfo()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadInfo() {
      this.loading = true
      const { deposit_info, field_values, forms } = await fetchDeposit(
        this.deposit_seq
      )

      this.info = deposit_info
      this.field_values = field_values
      this.forms = forms
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{ $t('admin.default_info') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="150" />
        <col width="*" />
        <col width="150" />
        <col width="*" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('admin.kyc_cdd_name_id') }}</div></th
          >
          <td>{{ info.user_name }} ({{ info.user_id }})</td>
          <th scope="row"
            ><div>{{ $t('admin.email_address') }}</div></th
          >
          <td>{{ info.email_address }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('admin.asset_title') }}</div></th
          >
          <td>{{ info.asset_title }}</td>
          <th scope="row"
            ><div>{{ $t('wallet.account_number') }}</div></th
          >
          <td>{{ info.account_number }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('admin.modal_asset_code') }}</div></th
          >
          <td>{{ info.asset_code }}</td>
          <th scope="row"
            ><div>{{ $t('admin.request_amount') }}</div></th
          >
          <td>{{ info.request_amount }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('admin.status') }}</div></th
          >
          <td>{{ fromPairs(constants.deposit.status)[info.status] }}</td>
          <th scope="row"
            ><div>{{ $t('admin.regdate') }}</div></th
          >
          <td>{{ date('Y-m-d H:i:s', new Date(info.regdate)) }}</td>
        </tr>
      </tbody>
    </table>
    <FormViewer v-bind="{ field_values, forms }"></FormViewer>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
